// extracted by mini-css-extract-plugin
export default {"columnGroup":"ColumnGroupElement_columnGroup__vX8Mo"};